import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import { routes } from "../../common/routes/routes";
import { usePermissionsChecker } from "../../core/auth/Permissions";
import { Permission } from "../../core/common-types/permission.enum";
import {
  NavBarBase,
  NavBarBaseProps
} from "../../layout/nav-bar/components/NavBarBase";
import { NavBarLogo } from "../../layout/nav-bar/components/NavBarLogo";
import { NavBarNavItem } from "../../layout/nav-bar/components/NavbarNavItem";

interface SettingsNavBarProps extends NavBarBaseProps {}

export const SettingsNavBar: FC<SettingsNavBarProps> = ({}) => {
  const navigate = useNavigate();

  const hasPermission = usePermissionsChecker();
  const hasBpmPermission = hasPermission(Permission.ProsBpmWebAllowed);

  return (
    <NavBarBase
      headerProps={{
        logoProps: {
          text: "Settings",
          onRenderLogo: logoProps => (
            <NavBarLogo
              red
              {...logoProps}
              onClick={() => {
                navigate(routes.settings.networkAndSecurity.path);
              }}
            />
          )
        }
      }}
      beforeNavButtons={
        hasBpmPermission && (
          <NavBarNavItem
            text="Jump to ..."
            items={[
              routes.bpMobileDashboard.basePath,
              routes.bpMobileBooking.appointments,
              routes.bpMobileAddressBook.patients,
              routes.bpMobileTodo.userInbox
            ]}
          />
        )
      }
    />
  );
};
